import { EventEmitter } from '@angular/core';
import { Influencer } from '../../../../../models/influencer';
import { CommonConstant, listOrderedPlatforms } from '../../../../app.constants';
import { UserService } from '../../../../services/user.service';
import { FilterSearch } from '../../../../../models/filter-search';
var PreviewInfluencerItemComponent = /** @class */ (function () {
    function PreviewInfluencerItemComponent(userService) {
        this.userService = userService;
        this.influencer = new Influencer();
        this.selectedInfluencer = new EventEmitter();
        // TODO update this number when API is ready for influencer_group_id
        this.influencerGroupId = 0;
        this.platformList = [];
        this.platformList = listOrderedPlatforms;
    }
    PreviewInfluencerItemComponent.prototype.hasInfluencerData = function () {
        return this.influencer !== undefined;
    };
    PreviewInfluencerItemComponent.prototype.onSelectedInfluencer = function (influencer, e) {
        if (this.previewedMode) {
            influencer.previewed = !influencer.previewed;
        }
        else {
            influencer.selected = !influencer.selected;
        }
        e.stopPropagation();
        this.selectedInfluencer.emit(influencer);
    };
    PreviewInfluencerItemComponent.prototype.getInfluencerHandle = function (selectedInfluencer) {
        if (this.displayInfo === 'posts') {
            return selectedInfluencer.influencer_name;
        }
        if (Array.isArray(selectedInfluencer.channels) && selectedInfluencer.channels.length > 0) {
            return selectedInfluencer.channels[0].handle;
        }
        else {
            return selectedInfluencer.relativePath;
        }
    };
    PreviewInfluencerItemComponent.prototype.hasPlatform = function (platformId, influencer) {
        if (!influencer || !influencer.channels) {
            return false;
        }
        return influencer.channels.findIndex(function (channel) { return channel.platform.id === platformId; }) >= 0;
    };
    Object.defineProperty(PreviewInfluencerItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    PreviewInfluencerItemComponent.prototype.getPreviewedItemTitle = function (influencer) {
        return this.displayInfo === 'posts' ? influencer.title : influencer.influencer_name;
    };
    PreviewInfluencerItemComponent.prototype.getCountryCode = function (influencer) {
        return influencer && influencer.country_code ? influencer.country_code.toLowerCase() : CommonConstant.INTERNATION_COUNTRY_CODE;
    };
    Object.defineProperty(PreviewInfluencerItemComponent.prototype, "entryLink", {
        get: function () {
            if (this.displayInfo === 'posts') {
                return ['/post/'];
            }
            else {
                return ['/influencer/' + this.influencer.influencer_id + '/overview'];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PreviewInfluencerItemComponent.prototype, "linkParams", {
        get: function () {
            var params = {
                group_id: this.influencerGroupId,
                activeAccount: this.activeAccount,
                hideBackButton: true,
                influencerId: undefined,
                fullUrl: undefined,
                relativePath: undefined,
                urlHash: undefined
            };
            if (this.displayInfo === 'posts') {
                params.influencerId = this.influencer.id;
                params.fullUrl = this.influencer.url;
                params.relativePath = this.influencer.relativepath;
                params.urlHash = this.influencer.urlHash;
            }
            if (this.discoverFilter && this.discoverFilter.audienceFilters.length > 0) {
                params = Object.assign({}, params, {
                    target: 'discover'
                });
            }
            return params;
        },
        enumerable: true,
        configurable: true
    });
    return PreviewInfluencerItemComponent;
}());
export { PreviewInfluencerItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/preview-selected-influencers/preview-influencer-item/preview-influencer-item.component.ts.pre-build-optimizer.js